@let items = $values();
@let control = $control();
@let displayName = $displayName();
@let nameField = $nameField();
@let description = $description();

<unity-control-wrapper [control]="$control()" [description]="$description()" [displayName]="$displayName()" [showHint]="$showHint()">
  <kendo-dropdownlist
    #dropdownlist
    unityClearableDropdownlist
    ngDefaultControl
    adaptiveMode="auto"
    [data]="items | sort: $defaultSortCfg()"
    [textField]="nameField"
    [valueField]="$idField()"
    [formControl]="control"
    [valuePrimitive]="$valuePrimitive()"
    [defaultItem]="$defaultItem()"
    [adaptiveTitle]="displayName"
    [adaptiveSubtitle]="description"
    (clearedEvent)="reset()"
    (selectionChange)="onSelectionChange($event)">
    <ng-template kendoDropDownListNoDataTemplate> Nothing available to select </ng-template>
    <ng-template let-item kendoDropDownListValueTemplate>
      @if (item) {
        <span [title]="item[nameField]">{{ item[nameField] }}</span>
      } @else {
        <span #no_selection class="inline italic"> (no selection) </span>
      }
    </ng-template>
  </kendo-dropdownlist>
</unity-control-wrapper>
